import * as React from "react";
import { Box, List, Typography, useTheme } from "@mui/material";
import { Await, Link, NavLink, useRouteLoaderData } from "react-router-dom";
import type { RootLoader } from "@/types/RootLoader";
import { useMainMenu } from "../helpers";
import tinyAlbertSymbol from "../../../assets/logos/tiny-albert-symbol-color.svg";
import PlanInfo from "../../PlanInfo/PlanInfoNew";
import ProfileMenu from "../../ProfileMenu";

function TopMenu() {
  const { accountInfo } = useRouteLoaderData("root") as RootLoader;
  const mainMenu = useMainMenu();
  const theme = useTheme();

  return (
    <Box
      component="nav"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      px={5}
      sx={{
        borderBottom: "1px solid #e0e0e0",
        background: "white",
        top: 0,
        position: "sticky",
        zIndex: theme.zIndex.appBar,
      }}
    >
      {/* Logo and Navigation */}
      <Box display="flex" alignItems="center">
        <Link
          to="dashboard"
          style={{ display: "inline-flex", marginRight: 32 }}
        >
          <img
            src={tinyAlbertSymbol}
            alt="Tiny Albert Logo"
            style={{ width: 32, height: 32 }}
          />
        </Link>

        <List
          sx={{
            display: "flex",
            gap: 5,
            flexDirection: "row",
            padding: 0,
            margin: 0,
          }}
        >
          {mainMenu.map((menuItem) => (
            <NavLink
              key={menuItem.name}
              to={menuItem.to}
              style={{ textDecoration: "none" }}
            >
              {({ isActive }) => (
                <Box
                  py={5}
                  sx={{
                    position: "relative",
                    color: isActive
                      ? theme.palette.primary.main
                      : theme.palette.grey[80],
                    transition: "color 0.3s ease",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: -1,
                      left: 0,
                      right: 0,
                      height: 3,
                      backgroundColor: theme.palette.primary.main,
                      transform: isActive ? "scaleX(1)" : "scaleX(0)",
                      transformOrigin: "center",
                      transition: "transform 0.3s ease",
                    },
                    "&:hover": {
                      color: theme.palette.primary.main,
                      "&::after": {
                        transform: "scaleX(1)",
                      },
                    },
                  }}
                >
                  <Typography
                    variant={isActive ? "label1" : "label1R"}
                    color="inherit"
                  >
                    {menuItem.name}
                  </Typography>
                </Box>
              )}
            </NavLink>
          ))}
        </List>
      </Box>

      <Box display="flex" gap={5} alignItems="center">
        <PlanInfo />
        <React.Suspense>
          <Await resolve={accountInfo}>
            <ProfileMenu collapsed />
          </Await>
        </React.Suspense>
      </Box>
    </Box>
  );
}

export default TopMenu;
